import React from "react";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <div className="about-section">

      <div className="about-container">
        
        {/* LEFT TEXT */}
        <div className="left-text">
          <p>
            Bakelore stands as a testament to the enduring magic that happens
            when two friends follow their passion and turn it into something truly extraordinary.
          </p>

          <p>
            At Bakelore we believe in not selling baked goods but an experience 
            to take you back to the cherished era with our recipes perfected 
            with carefully chosen ingredients.
          </p>

          <p>
            In a nutshell, birth of bakelore is haven for those who sought 
            nostalgic bakery style savories, baked goods, desserts and beverages 
            with genuine human touch in every bite with an aesthetic retreat 
            for the senses, echoed with warmth and camaraderie of loved ones 
            and cherished friendship.
          </p>
        </div>

        {/* CENTER LOGO SECTION */}
        <div className="center-logo">
          <img 
            src="https://bakelore.com/images/bakelore-website-logo-about.png" 
            alt="Bakelore Logo" 
            className="logo-img"
          />
          {/* <h2 className="brand-name">Bakelore</h2>
          <p className="tagline">BAKING THE DIFFERENCE</p> */}
        </div>

        {/* VERTICAL DOTTED LINE */}
        <div className="divider"></div>

        {/* RIGHT TEXT */}
        <div className="right-text">
          <p>The 'B' denotes the emphasis on the power of baking</p>
          <p>
            The "Wheat" symbol metaphorically denotes germination of a new 
            beginning in the era of baking.
          </p>
          <p>
            The break in the letter 'B' signifies the different horizons we want 
            to tap in the field of baking the difference.
          </p>
          <p>Inculcating the lore of traditional baking in modern times.</p>
          <p>No one ever made a difference by being like everyone else.</p>
        </div>

      </div>
    </div>
  );
};

export default AboutSection;
